
import React, { useEffect, useMemo, useState } from 'react';
import { Box, Button, Drawer, Typography } from '@mui/material';
import AppModal from '../Modal/AppModal';
import CheckCircle from '../../assets/DigitalCoursesAsset/checkcircle.svg'
import { useNavigate, useParams } from 'react-router-dom';
import TrackingSidebar from '../TrackingSidebar/TrackingSidebar';
import { useGet } from '../../hooks/useApi';

const ReusableDrawer = ({
  state,
  onClose,
  SidebarContent,
  TabPanel,
  setOnClose,
  FormContent,
  title,
  drawerType,
  subtitle,
  width = '35%',
  item_details
}) => {
  const [openModal, setOpenModal] = useState(false)
  const navigate = useNavigate()
  const [trackingSidebar,setTrackingSidebar] = useState(false)
  const courseMessageContent = {
    beforeSpan: "Congratulations! You've successfully purchased ",
    spanContent: "Mastering Social Media Marketing",
    afterSpan: " All course materials have been sent to your email and WhatsApp. Let's start learning."
  };
  const giftMessageContent = {
    beforeSpan: "Congratulations! You’ve successfully completed payment for order  ",
    spanContent: "#123456,",
    afterSpan: "  your tracking code will be sent to your whatsappa and your email within 48 hours"
  };
  // console.log(state);

  const [showCourse, setShowCourse] = useState(null); // State to store the selected course
  const [fetchedCourses, setFetchedCourses] = useState(null); // State to store courses after fetch

  // Fetch courses only when they are not fetched yet
  const { data: courses, error: coursesErr, isLoading: coursesLoader } = useGet('/api/Courses/all-courses', {
    staleTime: 60000, // Prevent refetching for 1 minute
  });
  
 const {id} = useParams();
 const userEmail = sessionStorage.getItem("userEmail");
 const customerId = sessionStorage.getItem("userId"); 
  
  // Memoize courses to avoid recalculating on each render
  const coursesList = useMemo(() => courses?.data || [], [courses]);

  // Only fetch courses once
  useEffect(() => {
    if (courses && !fetchedCourses) {
      setFetchedCourses(courses.data); // Save the fetched courses in the state
    }
  }, [courses, fetchedCourses]); // Only run when courses change or courses haven't been set yet

  useEffect(() => {
    if (fetchedCourses?.length > 0) {
      const foundCourse = fetchedCourses.find(course => {
        console.log('courseId from list:', course.courseId); // Log each courseId
        console.log('compare c', Number(course.courseId) === Number(id));
        return Number(course.courseId) === Number(id);
      });

      setShowCourse(foundCourse);
    }

    console.log('s',showCourse);
    
  }, [fetchedCourses, id,showCourse]); 
 
  console.log(customerId)
const { 
  data: giftOrderHistory, 
  error: giftOrderErr, 
  isLoading: giftOrderLoader 
} = useGet(`api/GiftItemOrders/order-history?userEmail=${customerId}`);
const giftOrderItems = useMemo(() => giftOrderHistory?.data || [], [giftOrderHistory]);
console.log('ts',giftOrderItems)

 
 const [showGift, setShowGift] = useState(null); // State to store the selected course
 const [fetchedGift, setFetchedGift] = useState(null); // State to store courses after fetch



 // Only fetch courses once
 useEffect(() => {
   if (giftOrderHistory && !fetchedGift) {
     setFetchedGift(giftOrderHistory.data); // Save the fetched courses in the state
   }
 }, [giftOrderHistory, fetchedGift]); // Only run when courses change or courses haven't been set yet
 useEffect(() => {
  if (fetchedGift?.length > 0) {
    const foundGift = fetchedGift.find(gift => {
      console.log('giftId from list:', gift.productId
        ); // Log each courseId
      console.log('compare g', Number(gift.productId
        ) === Number(id));
      return Number(gift.productId) === Number(id);
    });

    setShowGift(foundGift); // Set the course once it's found
  }

  console.log('s',showGift);
  
}, [fetchedGift, id,showGift]); // Only run when courses or productId change
  const handleCourseHistoryClick = () =>{
    navigate('/product/digital-courses/order-history')
  }
  const handleGiftHistoryClick = () =>{
    navigate('/product/giftshop/order-history')
  }
  const handleTrackingClick = () =>{
    setOpenModal(false)
    setTrackingSidebar(true)
  }
  const handleCloseTrackingSidebar = ()=>{
    setTrackingSidebar(false)
  }
  return (
    <div>
      <React.Fragment key={'right'}>
        <Drawer
          anchor={'right'}
          open={state}
          onClose={onClose}
          sx={{
            zIndex: 1500,
            '& .MuiDrawer-paper': {
              backgroundColor: '#f5f5f5',
              borderRadius: '20px 0 0 20px',
              width: width,
              padding: '16px',
              display:{md: 'block', xs:'none'},
              fontFamily: theme=> theme.typography.smallText,
            }
          }}
        >
          {/* Render sidebar content if provided */}
          {SidebarContent && <SidebarContent onClose={onClose} />}
          
          {/* Render title if provided */}
          {title && (
            <Typography 
              variant='h4' 
              sx={{
                color: 'rgba(86, 4, 246, 1)', 
                textAlign: 'center', 
                mt: 2
              }}
            >
              {title}
            </Typography>
          )}
          {TabPanel && <TabPanel setOnClose={setOnClose} setOpenModal={setOpenModal} /> }
          
          {/* Render subtitle if provided */}
          {subtitle && (
            <Typography 
              sx={{
                fontSize: '.8rem', 
                textAlign: 'center', 
                my: 2
              }}
            >
              {subtitle}
            </Typography>
          )}
          
          {/* Render form content if provided */}
          {FormContent && <FormContent setOnClose={setOnClose} setOpenModal={setOpenModal} item_details={item_details}/>}
        </Drawer>
        {/* {openModal && <AppModal setShowModal={setOpenModal} showModal={openModal}/>} */}
        {openModal && drawerType==='course' && <AppModal setShowModal={setOpenModal} showModal={openModal} icon={CheckCircle} title='Purchase Successful.' message={courseMessageContent} >
        <Box sx={{border: '1px solid #D2D1D6', borderRadius: '8px', padding: {md: 2, xs: 1}, display:'flex', flexDirection:'column', width:'100%', marginTop: 4}}>
             <Box sx={{borderBottom: '1px solid #D2D1D6', marginBottom: 1, display:'flex', justifyContent:'space-between'}}>
              <Typography sx={{textTransform:'capitalize', fontSize: 12}}>
                 Course Purchased
              </Typography>
              <Typography sx={{textTransform:'capitalize', fontSize: 12}}>{showCourse?.courseTitle}</Typography>
           
             </Box>
             <Box sx={{borderBottom: '1px solid #D2D1D6', marginBottom: 1, display:'flex', justifyContent:'space-between',marginTop: 1}}>
              <Typography sx={{textTransform:'capitalize',fontSize: 12}}>
              quantity
              </Typography>
              <Typography sx={{fontSize: 12}}>1 Unit</Typography>
             
             </Box>
             <Box sx={{borderBottom: '1px solid #D2D1D6', marginBottom: 1, display:'flex', justifyContent:'space-between',marginTop: 1,fontSize: 12}}>
              <Typography sx={{textTransform:'capitalize',fontSize: 12}}>
              price
              </Typography>
              <Typography sx={{fontSize: 12}}>₦{showCourse?.price}</Typography>
             
             </Box>
          
           </Box>
           <Box sx={{display:'flex', flex: 1, alignItems:'center', justifyContent: 'center', marginTop: {md: 4, xs: 2},marginBottom: {md: 0, xs: 2}, width: '100%'}}>



 {/* Add to Favorites Button  */}
<Box sx={{ marginTop: 1,width: 'auto' }}>
  <Button
  onClick={handleCourseHistoryClick}
    variant="contained"
    color="secondary"
    sx={{
      width: '100%',
      
      padding: {md: '10px 20px', xs: '5px 8px'},
      border: '1px solid #CBB1FC',
      borderRadius: '25px',
     
      textTransform:'capitalize',
      backgroundColor:'#fff',
      color:'#5604F6',
   
    }}
  >
    view recent orders
  </Button>
</Box>



</Box>
<Box sx={{alignSelf:'flex-start', marginTop: 2}}>
  <Typography>Need help?</Typography>
  <Typography>
  Contact our support team via <span style={{color: '#F6A704', cursor:'pointer'}}>WhatsApp or email</span>   for assistance.</Typography>
</Box> 
          
          </AppModal>}
          {openModal && drawerType==='gift' && <AppModal setShowModal={setOpenModal} showModal={openModal} icon={CheckCircle} title='Purchase Successful.' message={giftMessageContent} >
        <Box sx={{border: '1px solid #D2D1D6', borderRadius: '8px', padding: {md: 2, xs: 1}, display:'flex', flexDirection:'column', width:'100%', marginTop: 4}}>
             <Box sx={{borderBottom: '1px solid #D2D1D6', marginBottom: 1, display:'flex', justifyContent:'space-between'}}>
              <Typography sx={{textTransform:'capitalize', fontSize: 12}}>
                Gift Item Purchased
              </Typography>
              <Typography sx={{textTransform:'capitalize', fontSize: 12}}>{showGift?.productName}</Typography>
           
             </Box>
             <Box sx={{borderBottom: '1px solid #D2D1D6', marginBottom: 1, display:'flex', justifyContent:'space-between',marginTop: 1}}>
              <Typography sx={{textTransform:'capitalize',fontSize: 12}}>
              quantity
              </Typography>
              <Typography sx={{fontSize: 12}}>{showGift?.quantity} Unit</Typography>
             
             </Box>
             <Box sx={{borderBottom: '1px solid #D2D1D6', marginBottom: 1, display:'flex', justifyContent:'space-between',marginTop: 1,fontSize: 12}}>
              <Typography sx={{textTransform:'capitalize',fontSize: 12}}>
              price
              </Typography>
              <Typography sx={{fontSize: 12}}>₦{showGift?.pricePerUnit}</Typography>
             
             </Box>
             <Box sx={{borderBottom: '1px solid #D2D1D6', marginBottom: 1, display:'flex', justifyContent:'space-between'}}>
              <Typography sx={{textTransform:'capitalize',fontSize: 12}}>
              order I.D
              </Typography>
              <Typography sx={{fontSize: 12}}>{showGift?.orderId}</Typography>
             
             </Box>
           </Box>
           <Box sx={{display:'flex', flex: 1, alignItems:'center', justifyContent: 'space-between', marginTop: {md: 4, xs: 2},marginBottom: {md: 0, xs: 2}, width: '100%'}}>



 {/* Add to Favorites Button  */}
<Box sx={{ marginTop: 1,width: 'auto' }}>
  <Button
  onClick={handleGiftHistoryClick}
    variant="contained"
    color="secondary"
    sx={{
      width: '100%',
      
      padding: {md: '10px 20px', xs: '5px 8px'},
      border: '1px solid #CBB1FC',
      borderRadius: '25px',
     
      textTransform:'capitalize',
      backgroundColor:'#fff',
      color:'#5604F6',
   
    }}
  >
    view recent orders
  </Button>
</Box>



<Box sx={{ marginTop: 2, width: 'auto'}}>
  <Button
    variant="contained"
    color="success"
    onClick={handleTrackingClick}
    sx={{
      width: '100%',
      padding: {md: '10px 20px', xs: '5px 8px'},
      borderRadius: '25px',
        textTransform:'capitalize',
        backgroundColor: '#5604F6',
        color:'#fff'
    }}
  >
    Track your order
  </Button>
</Box>
</Box>
<Box sx={{alignSelf:'flex-start', marginTop: 2}}>
  <Typography>Need help?</Typography>
  <Typography>
  Contact our support team via <span style={{color: '#F6A704', cursor:'pointer'}}>WhatsApp or email</span>   for assistance.</Typography>
</Box> 
          
          </AppModal>}
          {trackingSidebar && <TrackingSidebar onClose={handleCloseTrackingSidebar} state={trackingSidebar}/>}
      </React.Fragment>
    </div>
  );
};

export default ReusableDrawer;